import React, {useState} from 'react';
import {Button} from 'flowbite-react';
import {moment, MomentExtensions} from '../../../services/moment-extensions';
import DatePicker, {DateObject} from "react-multi-date-picker";

const RangeDatePicker = ({setChartRange, skipMode = false, chartRange}) => {
    const [mode, setMode] = useState('month');
    const [fromDate, setFromDate] = useState(skipMode ? null : new DateObject().subtract(90, 'days'));
    const [toDate, setToDate] = useState(skipMode ? null : new DateObject());

    // Helper function to format date for backend (always in API format using default locale)
    const formatDateForBackend = (dateValue) => {
        // DateObject gives us a locale-formatted string, but we need to parse with the current locale format
        const currentFormat = MomentExtensions.getLocaleFormats().shortDate;
        return moment(dateValue?.format(), currentFormat).toApiDateTime();
    };

    const handleRangeChange = (newDate, type) => {

        if (skipMode) {
            setChartRange({
                ...chartRange,
                mode: mode,
                [type]: formatDateForBackend(newDate),
            });
            if (type === 'from') {
                setFromDate(newDate);
            }
            if (type === 'to') {
                setToDate(newDate);
            }
            return;
        }


        if (type === 'from') {
            setChartRange({
                from: formatDateForBackend(newDate),
                to: formatDateForBackend(toDate),
                mode: mode
            })
            setFromDate(newDate)
        }

        if (type === 'to') {
            setChartRange({
                from: formatDateForBackend(fromDate),
                to: formatDateForBackend(newDate),
                mode: mode
            })
            setToDate(newDate)
        }
    }


    React.useEffect(() => {
        if (skipMode && chartRange && chartRange.from === null && chartRange.to === null) {
            setFromDate(null);
            setToDate(null);
        }

    }, [chartRange, skipMode]);


    React.useEffect(() => {
            if (!skipMode)
                setChartRange({
                    from: formatDateForBackend(fromDate),
                    to: formatDateForBackend(toDate),
                    mode: mode
                })
        },
        /* eslint-disable react-hooks/exhaustive-deps */
        []);

    const changeMode = (mode) => {
        setMode(mode);
        // Only update the mode, don't change from/to dates to avoid triggering API call
        setChartRange(prev => ({
            ...prev,
            mode: mode
        }))
    }

    return (
        <div className={"flex flex-row sl-gap-3"}>
            {!skipMode && <Button.Group>
                <Button className={`${mode !== 'week' ? "bg-white" : "bg-gray-300"} hover:bg-gray-300`} color="gray"
                        onClick={() => changeMode('week')}>Week</Button>

                <Button className={`${mode !== 'month' ? "bg-white" : "bg-gray-300"} hover:bg-gray-300`} color="gray"
                        onClick={() => changeMode('month')}>Month</Button>
            </Button.Group>
            }

            <div
                className={"sl-flex sl-gap-1 sl-border flex flex-row sl-gap-2 sl-bg-white sl-border-radius-8 sl-border-gray-300 sl-text-sm sl-font-medium sl-text-gray-700 sl-pl-16 sl-pr-16 sl-cursor-pointer"}

            >
                <DatePicker
                    format={MomentExtensions.getLocaleFormats().shortDate}
                    value={fromDate}
                    onChange={(value) => handleRangeChange(value, 'from')}
                    minDate={skipMode ? null : new DateObject().subtract(180, 'days')}
                    maxDate={toDate}
                    weekStartDayIndex={MomentExtensions.getLocaleFormats().weekStart}
                    render={(value, openCalendar) => {
                        return (
                            <span
                                className={"sl-flex sl-flex-row sl-gap-1"}
                                style={{
                                    height: '40px',
                                }}
                                onClick={openCalendar}>
                                        <svg className={"sl-m-auto"} xmlns="http://www.w3.org/2000/svg" width="20"
                                             height="20"
                                             viewBox="0 0 20 20"
                                             fill="none">
              <path
                  d="M13.3333 1.6665V4.99984M6.66667 1.6665V4.99984M2.5 8.33317H17.5M4.16667 3.33317H15.8333C16.7538 3.33317 17.5 4.07936 17.5 4.99984V16.6665C17.5 17.587 16.7538 18.3332 15.8333 18.3332H4.16667C3.24619 18.3332 2.5 17.587 2.5 16.6665V4.99984C2.5 4.07936 3.24619 3.33317 4.16667 3.33317Z"
                  stroke="#344054" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>

                                        <span className={"sl-m-auto"}>{value ? value : 'From'}</span>
                                    </span>
                        )
                    }}
                />

                <span className={"sl-m-auto"}>{" - "}</span>
                <DatePicker
                    format={MomentExtensions.getLocaleFormats().shortDate}
                    value={toDate}
                    onChange={(value) => handleRangeChange(value, 'to')}
                    minDate={fromDate}
                    maxDate={new DateObject()}
                    weekStartDayIndex={MomentExtensions.getLocaleFormats().weekStart}
                    render={(value, openCalendar) => {
                        return (
                            <span
                                className={"sl-flex sl-flex-row sl-gap-1"}
                                style={{
                                    height: '40px',
                                }}
                                onClick={openCalendar}>
                                        <span className={"sl-m-auto"}>{value ? value : 'To'}</span>
                                    </span>
                        )
                    }}
                />
            </div>
        </div>
    );
};

export default RangeDatePicker;
